<template>
    <v-dialog v-model="_value" persistent max-width="600px">
        <v-card>
            <v-parallax dark class="blue-grey darken-3 pb-0" height="70">
                <v-spacer></v-spacer>
                <v-container>
                    <v-layout><br>
                        <h4 class="subheading font-weight-medium">UPDATE MOTORCYCLE</h4>
                    </v-layout>
                </v-container>
            </v-parallax>

            <v-container grid-list>
                <v-layout wrap>
                    <v-flex xs12>
                        <v-autocomplete v-model="forChangeMotorcycle.dealer" label="Dealer" :items="dealers" persistent-hint hide-no-data leave-absolute hide-details>
                            <template v-slot:append-outer>
                                <v-slide-x-reverse-transition mode="out-in">
                                </v-slide-x-reverse-transition>
                            </template>
                        </v-autocomplete>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                        <v-select v-model="forChangeMotorcycle.classification" label="Classification*" required :items="classifications" hide-details readonly
                        ></v-select>
                    </v-flex>

                     <v-flex xs12>
                        <v-text-field label="Make*" v-model="forChangeMotorcycle.make" hide-details required readonly></v-text-field>
                    </v-flex>

                    <v-flex xs12>
                        <v-text-field label="Model*" v-model='forChangeMotorcycle.model' hide-details required readonly></v-text-field>
                    </v-flex>

                    <v-flex xs12>
                        <v-text-field label="Year Model" v-model='forChangeMotorcycle.yearModel' hide-details placeholder="Optional"></v-text-field>
                    </v-flex>

                    <v-flex xs12>
                        <v-text-field label="Color" v-model='forChangeMotorcycle.color' hide-details placeholder="Optional"></v-text-field>
                    </v-flex>

                    <v-flex xs12>
                        <v-text-field label="Engine Number" v-model='forChangeMotorcycle.engineNumber' hide-details placeholder="Optional"></v-text-field>
                    </v-flex>

                    <v-flex xs12>
                        <v-text-field label="Chassis Number" v-model='forChangeMotorcycle.chassisNumber' hide-details placeholder="Optional"></v-text-field>
                    </v-flex>

                    <v-flex xs12>
                        <v-text-field label="Plate Number" v-model='forChangeMotorcycle.plateNumber' hide-details placeholder="Optional"></v-text-field>
                    </v-flex>

                    <v-flex xs12>
                        <v-text-field label="Date of Purchase" v-model='forChangeMotorcycle.dateOfPurchase' hide-details placeholder="Optional"></v-text-field>
                    </v-flex>

                    <v-flex xs12>
                        <v-text-field label="Registartion Date" v-model='forChangeMotorcycle.registrationDate' hide-details placeholder="Optional"></v-text-field>
                    </v-flex>

                    <v-flex xs12>
                        <v-text-field label="Mileage(km)" v-model='forChangeMotorcycle.odometer' required hide-details readonly placeholder="Optional"></v-text-field>
                    </v-flex>
                </v-layout>

                <v-layout justify-center>
                    <v-btn dark color="red accent-4" @click="_value=false">Cancel</v-btn>
                    <v-btn dark color="blue darken-4" @click="updateMotorcycle(forChangeMotorcycle)">Save</v-btn>
                </v-layout>
            </v-container> 
        </v-card>
        <Snackbar v-model="snackbar.show" :type="snackbar.type" :message="snackbar.message" />
        <Progress v-model="progress.show" :message="progress.message" />
    </v-dialog>
</template>

<script>
import "../../node_modules/firebaseui/dist/firebaseui.css"
import { mapGetters, mapActions, mapState } from "vuex"
import { db } from '../main.js'
import _ from 'lodash'
import Snackbar from './Snackbar.vue'
import Progress from './Progress.vue'

export default {
    components: {
        Snackbar,
        Progress,
    },
    props: {
        forChangeMotorcycle: Object,
        show: {
            type: Boolean,
            default: false
        },
    },
    model: {
        prop: 'show',
        event: 'change'
    },
	data: () => ({
        materialMaster: [],
        dealers: [],
        brands: [],
        models: [],
        dealer: "",
        make: "",
        model: "",
        yearModel: null,
        yearModelMenu: false,
        odometer: "",
        plateNumber: "",
        progressDialog: false,
        showAlert: false,
        alertColor: "",
        alertMessage: "",
        motorcycleHistoryDialog: false,
        classification: "",
        classifications: ['CUB', 'Automatic','Business','Hi-End'],
        mcColor: "",
        progress: {
            message: "",
            show: false,
        },
        snackbar: {
            responseMessage: "",
            show: false,
            type: "success"
        },
    }),
 
    methods : {
        async fetchNsMc() {
            let self = this
            self.materialMaster = []
            await db.collection("Motorcycles").get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc) {
                    self.materialMaster.push(doc.data())
                })
            }).catch(function(error) {
                console.log(error)
            })
        },

        showProgress(message) {
            this.progress.message = message
            this.progress.show = true
        },
        stopProgress() {
            this.progress.show = false
        },

        save(date) {
            this.$refs.yearModelMenu.save(date)
            this.$refs.picker.activePicker = "YEAR"
            this.yearModelMenu = false
        },

        refresh(){
            let self = this
            self.classification = ""
            self.dealer = ""
            self.make = ""
            self.model = ""
            self.yearModel = ""
            self.odometer = ""
            self.plateNumber = ""
            // self.progressDialog = false
        },

        cancel() {
            let self = this
            self.refresh()
            self.$store.dispatch("setMotorcycle", false)
        },

        updateMotorcycle(mc) {
            let self = this
            if (mc.make === "") {
                self.alertColor = "red accent-4"
                self.alertMessage = "Make/Brand should not be blank"
                self.showAlert = true
            } else if (mc.model === "") {
                self.alertColor = "red accent-4"
                self.alertMessage = "Model should not be blank"
                self.showAlert = true
            } else if (mc.classification === "") {
                self.alertColor = "red accent-4"
                self.alertMessage = "Classification should not be blank"
                self.showAlert = true
            } else {
                self.showProgress("Updating Motorcycle Details...") 
                db.collection("McDetails"+self.$stage).doc(mc.id)
                .update({
                    "dealer": mc.dealer,
                    "make": mc.make,
                    "classification": mc.classification,
                    "model": mc.model,
                    "yearModel": mc.yearModel,
                    "color": mc.color,
                    "engineNumber": mc.engineNumber,
                    "chassisNumber": mc.chassisNumber,
                    "plateNumber": mc.plateNumber,
                    "odometer": mc.odometer,
                    "dateOfPurchase": mc.dateOfPurchase,
                    "registrationDate": mc.registrationDate,
                }).then(function() {
                    // self.fetchMcDetails()
                    // self.refresh()
                    self.stopProgress()
                    self._value=false
                }).catch(error => console.log(error))
            }
        },

        fetchDealers() {
            let self = this
            self.dealers = []
            
            db.collection("Settings"+self.$stage).doc("Dealers")
            .collection("Items").get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc) {
                    self.dealers.push(doc.data().dealer)
                })
            }).catch(function(error) {
                console.log(error)
            })
        },
    },

    mounted() {
        this.fetchNsMc()
        this.fetchDealers()
    },

    watch: {
        yearModelMenu (val) {
            val && this.$nextTick(() => (this.$refs.picker.activePicker = "YEAR"))
        },

        yearModel (val) {
            let self = this
            if (val !== ""){
                self.yearModel = val.split('-')[0].trim()
            }
        },

        classification(val) {
            let self = this
            self.brands = []
            self.models = []
            self.make = ""
            self.model = ""
            self.materialMaster.forEach(function(res) {
                if (res.classification === val) {
                    self.brands.push(res.brand)
                }
            })
        },
        make(val) {
            let self = this
            self.models = []
            self.model = ""
            self.materialMaster.forEach(function(res) {
                if (res.brand === val && res.classification === self.classification) {
                    self.models.push(res.model)
                }
            })
        }, 
    },

    computed : {
        ...mapGetters(["user","appointment"]),
        ...mapState(["Auth","Scheduler"]),
        _value: {
            get: function () {
                return this.show
            },
            set: function (newVal) {
                this.$emit('change', newVal)
            }
        }
    }
}

</script>
